import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllUserCheckIn,
  GetAllUserCheckInSummary,
  GetUserCheckInHistory,
} from "store/middlewares/checkIn";

// isDeleteMeFulFilled
export const checkInSlice = createSlice({
  name: "checkIn",
  initialState: {
    checkInQuestionLoading: false,
    checkInQuestion: null,
    checkInSummaryLoading: false,
    checkInsummary: null,
    checkInHistoryLoading: false,
    checkInHistory: null,
  },
  extraReducers(builder) {
    builder

      //get user
      .addCase(GetAllUserCheckIn.pending, (state) => {
        state.checkInQuestionLoading =
          state.checkInQuestion?.data?.length > 0 ? false : true;

        state.checkInQuestion =
          state.checkInQuestion?.data?.length > 0
            ? state.checkInQuestion
            : null;
      })
      .addCase(GetAllUserCheckIn.fulfilled, (state, action) => {
        state.checkInQuestionLoading = false;
        state.checkInQuestion = action.payload.response;
      })
      .addCase(GetAllUserCheckIn.rejected, (state) => {
        state.checkInQuestionLoading = false;
        state.checkInQuestion = null;
      })
      .addCase(GetAllUserCheckInSummary.pending, (state) => {
        state.checkInSummaryLoading =
          state.checkInsummary?.data?.length > 0 ? false : true;

        state.checkInQuestion =
          state.checkInsummary?.data?.length > 0 ? state.checkInsummary : null;
      })
      .addCase(GetAllUserCheckInSummary.fulfilled, (state, action) => {
        state.checkInSummaryLoading = false;
        state.checkInsummary = action.payload.response;
      })
      .addCase(GetAllUserCheckInSummary.rejected, (state) => {
        state.checkInSummaryLoading = false;
        state.checkInsummary = null;
      })
      .addCase(GetUserCheckInHistory.pending, (state) => {
        state.checkInHistoryLoading =
          state.checkInHistory?.data?.length > 0 ? false : true;

        state.checkInQuestion =
          state.checkInHistory?.data?.length > 0 ? state.checkInHistory : null;
      })
      .addCase(GetUserCheckInHistory.fulfilled, (state, action) => {
        state.checkInHistoryLoading = false;
        state.checkInHistory = action.payload.response;
      })
      .addCase(GetUserCheckInHistory.rejected, (state) => {
        state.checkInHistoryLoading = false;
        state.checkInHistory = null;
      });
  },
});

export default checkInSlice.reducer;
